"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var error_png_1 = __importDefault(require("../../../assets/lootBox/error.png"));
var ErrorScreen = function (_a) {
    var show = _a.show;
    if (!show) {
        return null;
    }
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "lootbox--title" }, { children: "Ooops, eroare!" })), (0, jsx_runtime_1.jsx)("img", { src: error_png_1.default, alt: "error" })] });
};
exports.default = ErrorScreen;
